{
  "confirmPassword": {
    "match": "Les mots de passe ne correspondent pas",
    "required": "Le champ confirmation du mot de passe est requis"
  },
  "email": {
    "invalid": "L'email est invalide",
    "required": "Le champ email est requis"
  },
  "firstName": {
    "required": "Le champ prénom est requis"
  },
  "lastName": {
    "required": "Le champ nom est requis"
  },
  "password": {
    "minLength": "Le mot de passe doit contenir au moins 12 caractères",
    "lowercase": "Le mot de passe doit contenir au moins une lettre minuscule",
    "number": "Le mot de passe doit contenir au moins un chiffre",
    "required": "Le champ mot de passe est requis",
    "special": "Le mot de passe doit contenir au moins un caractère spécial",
    "uppercase": "Le mot de passe doit contenir au moins une lettre majuscule"
  },
  "phone": {
    "invalid": "Le numéro de téléphone est invalide",
    "smsHint": "Numero invalide pour l'envoi des SMS ! Mettre un 06 ou 07..."
  },
  "minLength": "Ce champ doit contenir au moins {min} caractères",
  "maxLength": "Ce champ ne doit pas dépasser {max} caractères",
  "positiveInt": "La valeur doit être supérieure à 0",
  "required": "Ce champ est requis",
  "requiredSelection": "Veuillez sélectionner au moins une valeur"
}
